import { KeyCodes } from '@/consts/keyCodes';

interface Params {
  onEnterPress: () => void;
}

const useKeyboard = ({ onEnterPress }: Params) => {
  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    switch (event.key) {
      case KeyCodes.Enter: {
        onEnterPress();
        break;
      }
      default:
        break;
    }
  };

  return { onKeyDown };
};

export default useKeyboard;
